<template>
  <div id="sovdetailreport" style="text-transform: capitalize;">
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
    </div>
  	<div class="datepickerwrap card">
      <div style="display:flex;justify-content: space-between;">
        <div  style="display:inline-flex;width:40%">
          <div class="datebox customSelect" style="width:50%!important">
            <select v-model="selected_website" class="form-control text-uppercase">
              <optgroup label="Retail" v-show='false'>
                <option value="all">All</option>
                <option value="https://www.amazon.com">Amazon US</option>
                <option value="https://www.amazon.fr">Amazon France</option>
                <option value="https://www.amazon.co.it">Amazon Italy</option>
                <option value="https://www.amazon.es">Amazon Spain</option>
                <option value="https://www.amazon.co.uk">Amazon UK</option>
                <option value="https://www.amazon.de">Amazon Germany</option>
                <option value="https://www.bestbuy.com">Best Buy US</option>
                <option value="https://www.costco.com">Costco US</option>
                <option value="https://www.currys.co.uk">Curry's UK</option>
                <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>  
                <option value="https://global.jd.com">JD GC</option>
                <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
                <option value="https://www.walmart.com">Walmart US</option>
              </optgroup>
              <optgroup label="Consumer OEM">
                <option value="https://br-store.acer.com">Acer Brazil</option>
                <option value="https://store.acer.com/en-us">Acer US</option>
                <option value="https://www.asus.com/fr">ASUS France</option>
                <option value="https://store.asus.com/us">ASUS US</option>
                <option value="https://www.dell.com/en-au">Dell Australia</option>
                <option value="https://www.dell.com/ja-jp">Dell Japan</option>
                <option value="https://www.dell.com/en-us">Dell US</option>
                <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
                <option value="https://store.hp.com/FranceStore">HP France</option>
                <option value="https://www8.hp.com/jp">HP Japan</option>
                <option value="https://store.hp.com/mx-es">HP Mexico</option>
                <option value="https://store.hp.com/UKStore">HP UK</option>
                <option value="https://store.hp.com/us">HP US</option>
                <option value="https://www.lenovo.com/au">Lenovo Australia</option>
                <option value="https://s.lenovo.com.cn">Lenovo China</option>
                <option value="https://www.lenovo.com/fr">Lenovo France</option>
                <option value="https://www.lenovo.com/de">Lenovo Germany</option>
                <option value="https://www.lenovo.com/gb">Lenovo UK</option>
                <option value="https://www.lenovo.com/us">Lenovo US</option>
                <option value="https://www.nec-lavie.jp">NEC Japan</option>
              </optgroup>
              <optgroup label="Commercial OEM" >
                <option value="https://www.hpstore.cn#commercial">Commercial HP China</option>
                <option value="https://store.hp.com/FranceStore#commercial">Commercial HP France</option>
                <option value="https://store.hp.com/GermanyStore#commercial">Commercial HP Germany</option>
                <option value="https://www8.hp.com/jp#commercial">Commercial HP Japan</option>
                <option value="https://store.hp.com/UKStore#commercial">Commercial HP UK</option>
                <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
                <option value="https://b2b.lenovo.com.cn#commercial">Commercial Lenovo China</option>
                <option value="https://www.lenovo.com/fr#commercial">Commercial Lenovo France</option>
                <option value="https://www.lenovo.com/de#commercial">Commercial Lenovo Germany</option>
                <option value="https://www.lenovo.com/jp#commercial">Commercial Lenovo Japan</option>
                <option value="https://www.lenovo.com/gb#commercial">Commercial Lenovo UK</option>
                <option value="https://www.lenovo.com/us#commercial">Commercial Lenovo US</option>
              </optgroup>
              <optgroup label="Commercial Reseller" >
                <option value="https://www.bechtle.com">Bechtle</option>
                <option value="https://www.cdw.com">CDW</option>
                <option value="https://www.inmac-wstore.com">Inmac</option>
                <option value="https://www.insight.com/en-US">Insight</option>
                <option value="https://www.connection.com">PC Connection</option>
                <option value="https://www.shi.com">SHI</option>
                <option value="https://www.technoworld.com">TechnoWorld</option>
              </optgroup>
            </select>
          </div>
          <div class="datebox customSelect" style="width:50%!important">
            <select v-model="device"  class="form-control text-uppercase">
              <option value="laptop">Laptop</option>
              <option value="desktop">Desktop</option>
              <option v-if="selected_website== 'https://www.lenovo.com/us#commercial' || selected_website == 'https://store.hp.com/GermanyStore#commercial' || selected_website=='https://store.hp.com/us#commercial' " value="neither">Neither</option>
            </select>
          </div>
          <button @click="refresh" class="btn primarycolor" type="button">
            <span>Submit</span>
          </button>
          <button @click="exportNow"  class="button exportButton" >Export</button>
        </div>
        <div>   
          <div class="datebox" style="margin-right:0">
            <button @click="backToSov" style="width:max-content;" class="btn navigationButton" type="button">
              <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon">
              <span> Back</span>
            </button>
          </div>
        </div>
      </div>  
      <div style="display:flex;justify-content: start; margin-top:20px">
        <div class="dateComponent mr-2"  >
          <div class="mb-1 dateComponentHeading">Previous Date Range</div>
          <div style="display:flex;">
            <div style="display:flex;margin-right:6px">
              <button class="datePickerBadge">From</button> 
              <datepicker  placeholder="From" @input="changeCustomDate" v-model="date.duration1From"/>
            </div>  
            <div style="display:flex">
              <button class="datePickerBadge">To</button> 
              <datepicker  placeholder="From" @input="changeCustomDate" v-model="date.duration1To" />
            </div>  
          </div>  
        </div>
        <div class="dateComponent">
          <div class="mb-1 dateComponentHeading">Current Date Range</div>
          <div style="display:flex;">
            <div style="display:flex;margin-right:6px">
              <button class="datePickerBadge">From</button> 
              <datepicker  placeholder="From" @input="changeCustomDate" v-model="date.duration2From" />
            </div>  
            <div style="display:flex">
              <button class="datePickerBadge">To</button> 
              <datepicker  placeholder="From" @input="changeCustomDate" v-model="date.duration2To" />
            </div>  
          </div>  
        </div>
      </div>
  	</div>
    <div class="">
      <!-- <div  style="display: flow-root;">
        <button  style="margin-bottom:10px" class="weavrpurple" @click="filterAddAction" v-if="!addFilter">Add Filter</button>
         <button @click="exportNow" style="margin-bottom:10px;float:right" class="weavrpurple" >Export</button>
      </div> -->
      <!-- <div v-if="addFilter" class="card p-2 filter" style="padding: 21px!important;background: #f5f5f5">
        <div class="row mt-2" v-for="(d,i) in filterRow">
          <div class="col-md-2 pr-0">
            <select v-model="d.filterKey" class="form-control text-uppercase">
             <option value="price">Price</option>
             <option value="reviews">Reviews</option>
             <option value="ratings">Ratings</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
            <select v-model="d.filterCondition" class="form-control text-uppercase">
              <option value="equals">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
           <input v-model="d.val1" class="form-control filval" type="text" placeholder="">
           <input v-if="d.filterCondition == 'between'" v-model="d.val2" class="form-control filval mt-2" type="text" placeholder="">
          </div>
       
          <div  class="col-md-2">
            <button @click="filterRemove(i)" class="btn filval btn-danger"> Remove </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 pt-4" style="text-align: center;">
            <button @click="filterApply" class="btn filval btn-primary mr-2">Apply Filter</button>
            <button v-if="filterRow.length < 3" @click="filterAddMore" class="btn filval btn-success mr-2"> Add more </button>
            <button class="btn filval btn-danger " @click="filterCancel"> Cancel </button>
          </div>
          
        </div>
      </div> -->
      <div class="">
        <div  v-for ="(d,i) in rows_details" :key="d.location"  class="card" style="margin: 10px">     
          <div class="space-between-header" style="margin-left: -5px;">
            <h4 class="graphHeading">{{ d.location }}</h4>
          </div> 
          <div class="borderBetween"></div>
          <h4 class="graphHeading mt-2">Systems Added</h4>
          <div class="py-2">
          <table :id="'systems_added_' + i" class="table">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in d.systems_added"  :key="i" :class="{'markitamd':r['processor'] == 'amd',
                'markitintel':r['processor'] == 'intel','markitsnap':r['processor'] == 'qualcomm snapdragon','markitna':r['processor'] == 'N/A',
                'markittek':r['processor'] == 'mediatek'}">
                <td :data-order="getDataOrder(r[d.field])" v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span v-if="d.field == 'processor' && r['processor']== 'amd' ">{{r[d.field].toUpperCase() }}</span>  
                      <span v-else>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="borderBetween"></div> 
          <h4 class="graphHeading mt-2" >Systems Removed</h4> 
          <div class="py-2"> 
          <table :id="'systems_removed_' + i" class="table">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in d.systems_removed"  :key="i" :class="{'markitamd':r['processor'] == 'amd',
                'markitintel':r['processor'] == 'intel','markitsnap':r['processor'] == 'qualcomm snapdragon','markitna':r['processor'] == 'N/A',
                'markittek':r['processor'] == 'mediatek'}">
                <td :data-order="getDataOrder(r[d.field])" v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span v-if="d.field == 'processor' && r['processor']== 'amd' ">{{r[d.field].toUpperCase() }}</span>  
                      <span v-else>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Loader from "./Components/Loader.vue"

export default {
  name: 'sovdetailreport',
  components: { Datepicker, Loader},
  data: function () {
    return {
    	selected_website:localStorage.selected_SOVWebsite,
      device:localStorage.selected_category,
      date:{
        duration1From: moment().subtract(14,'days').format('YYYY-MM-DD'),
        duration1To: moment().subtract(8,'days').format('YYYY-MM-DD'),
        duration2From: moment().subtract(7,'days').format('YYYY-MM-DD'),
        duration2To: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      oem_websites:['https://www.inmac-wstore.com','https://www.technoworld.com','https://www.bechtle.com','https://www.connection.com','https://www.shi.com','https://www8.hp.com/jp#commercial','https://www.lenovo.com/jp#commercial','https://b2b.lenovo.com.cn#commercial','https://www.hpstore.cn#commercial','https://www.nec-lavie.jp','https://fmv.fccl.fujitsu.com','https://www.dell.com/ja-jp','https://www.dell.com/en-au','https://www.lenovo.com/au','https://br-store.acer.com','https://s.lenovo.com.cn','https://store.hp.com/FranceStore','https://store.hp.com/mx-es','https://www.lenovo.com/fr','https://www.insight.com/en-US','https://store.hp.com/FranceStore#commercial','https://www.lenovo.com/fr#commercial','https://www.cdw.com','https://www.lenovo.com/gb#commercial','https://store.hp.com/UKStore#commercial','https://www.lenovo.com/de#commercial','https://store.hp.com/GermanyStore#commercial','https://www8.hp.com/jp','https://store.hp.com/us#commercial','https://www.lenovo.com/us#commercial','https://store.hp.com/UKStore','https://store.hp.com/us','https://www.asus.com/fr','https://store.asus.com/us','https://www.dell.com/en-us','https://store.acer.com/en-us','https://www.lenovo.com/us','https://www.lenovo.com/gb','https://www.lenovo.com/de'],
      columns_details:[],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      deviceMapper:{
        'laptop': 'PC',
        'desktop': 'Desktop'
      },
      filterRow: [],
      addFilter:false,
      filterKey: 'price',
      filterCondition: 'equals',
      filterVal1: '',
      filterVal2: '',
      websiteName: {
        "https://www.amazon.com": "Amazon US",
        "https://www.harveynorman.com.au": "Harvey Norman AU",
        "https://www.bestbuy.com": "Best Buy US",
        "https://www.currys.co.uk": "Curry's UK",
        "https://www.costco.com": "Costco US",
        "https://www.walmart.com": "Walmart US",
        "https://store.hp.com/us": "HP US",
        "https://global.jd.com": "JD GC",
        "https://store.asus.com/us": "ASUS US",
        "https://www.dell.com/en-us": "Dell US",
        "https://store.acer.com/en-us": "Acer US",
        "https://store.hp.com/UKStore":"HP UK",
        "https://www8.hp.com/jp": "HP Japan",
        "https://www.lenovo.com/us":"Lenovo US",
        "https://www.lenovo.com/gb":"Lenovo UK",
        "https://www.lenovo.com/de":"Lenovo Germany",
        "https://www.mediamarkt.de": "MediaMarkt DE",
        "https://store.hp.com/us#commercial": "Commercial HP US",
        "https://www.lenovo.com/us#commercial": "Commercial Lenovo US",
        "https://www.lenovo.com/de#commercial": "Commercial Lenovo Germany ",
        "https://store.hp.com/GermanyStore#commercial": "Commercial HP Germany",
        "https://www.cdw.com":"CDW",
        "https://www.insight.com/en-US":"Insight",
        "https://www.lenovo.com/fr#commercial": 'Commercial Lenovo France',
        "https://store.hp.com/FranceStore#commercial": "Commercial HP France",
        "https://store.hp.com/UKStore#commercial": 'Commercial HP UK',
        "https://www.lenovo.com/gb#commercial": "Commercial Lenovo UK",
        "https://www.lenovo.com/fr": 'Lenovo France',
        'https://store.hp.com/mx-es': 'HP Mexico',
        "https://store.hp.com/FranceStore": 'HP France',
        "https://br-store.acer.com": 'Acer Brazil',
        "https://www.lenovo.com/au": 'Lenovo Australia',
        "https://s.lenovo.com.cn": 'Lenovo China',
        "https://www.asus.com/fr":'Asus France',
        "https://www.dell.com/en-au": "Dell Australia",
        "https://www.dell.com/ja-jp": "Dell Japan",
        'https://fmv.fccl.fujitsu.com': 'Fujitsu Japan',
        'https://www.nec-lavie.jp': 'NEC Japan',
        'https://www.hpstore.cn#commercial': 'Commercial HP China',
        'https://www.lenovo.com/jp#commercial': 'Commercial Lenovo Japan',
        'https://b2b.lenovo.com.cn#commercial': 'Commercial Lenovo China',
        'https://www8.hp.com/jp#commercial': 'Commercial HP Japan',
        'https://www.shi.com': 'SHI',  
        'https://www.connection.com': 'PC Connection',  
        'https://www.bechtle.com': 'Bechtle',
        'https://www.technoworld.com': 'TechnoWorld',
        'https://www.inmac-wstore.com': 'Inmac'
      }
    }
  },
  mounted()
  {
    this.website_details()
    this.initCols()
  },
  methods: {
    goToSOVDetailReport(){
      window.location = '#/sov-detail-report'
    },
    exportNow(){
      let self = this
      self.loader = true
      let payload = {}
      payload.website = this.selected_website
      payload.item_category = self.device
      payload.data = this.rows_details
      payload.website_name = self.websiteName[self.selected_website]
      const url = "/api/v1/sov/products/compare/download"
      this.$http.post(url, payload).then(response => {
        self.loader = false
        window.location = response.body.data
      }, err => {
        self.loader = false
        console.log(err)
      });
    },
    getDataOrder(d){
      if((typeof(d)=='string') && (d.includes('.–')))
      {
        return '<span>' + d.replace('.–','') + '</span>'
      }
      return '<span>' + d + '</span>'

    },
    filterCancel(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.addFilter = false
      this.filterRow = []
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  

    },
    filterRemove(i){
      this.filterRow.splice(i,1)
    },
    filterAddAction(){
      this.addFilter = true
      let obj = {}
      obj.filterKey = 'price'
      obj.filterCondition = 'equals'
      obj.val1 = ''
      obj.val2 = ''
      this.filterRow.push(obj)
    },
    filterAddMore(){
      let obj = {}
      obj.filterKey = 'price'
      obj.filterCondition = 'equals'
      obj.val1 = ''
      obj.val2 = ''
      this.filterRow.push(obj)

    },

    filterCheck(dataset){
      
      let operators = {
        'equals': function(a, b, c) { return a==b },
        'gt': function(a, b, c) { return a > b },
        'gte': function(a, b, c) { return a >= b },
        'lt': function(a, b, c) { return a < b },
        'lte': function(a, b, c) { return a <= b },
        'between': function(a, b, c) { 
          if(!c)
            return a >= b
          if(!b)
            return (a <= c)
          
          return ((a >= b)&&(a <= c)) },
      }
      for(let [fi, fd] of this.filterRow.entries()) 
      {
        if(!fd.val1)
        {
          if(fi==this.filterRow.length-1)
          {
            return true
          }
          else
          {
            continue
          }
        }

        if (typeof(dataset[fd.filterKey])=='string')
          dataset[fd.filterKey] = dataset[fd.filterKey].replace('.–','').replace('$','').replace(" ",'').replace(",",'').replace(",",'')
        dataset[fd.filterKey] = parseFloat(dataset[fd.filterKey])
        dataset[fd.val1] = parseFloat(dataset[fd.val1])  
        dataset[fd.val2] = parseFloat(dataset[fd.val2])  
        if (operators[fd.filterCondition](dataset[fd.filterKey], fd.val1, fd.val2  ) == false)
        {
          return false
        }
      }
      return true

    },
    filterApply(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(this.filterCheck(dataset))
        {
          this.rows_details.push(dataset)
        }
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
    initCols(){
      if(this.oem_websites.includes(this.selected_website))
      {
        
        this.columns_details = [ 
          {label: 'SKU', field: 'item_id',sortable: false},
          {label: 'Name', field: 'product_name',sortable: false},
          {label: 'Processor Type', field: 'processor_type',sortable: false},
          {label: 'Processor Model', field: 'processor_model',sortable: false}]
      }
      else
      {
        this.columns_details = [  {label: 'Rank', field: 'order'},
          {label: 'Page', field: 'page'},
          {label: 'Brand', field: 'brand'},
          {label: 'Name', field: 'product_name',sortable: false},
          {label: 'Processor', field: 'processor',sortable: false},
          {label: 'Processor Type', field: 'processor_type',sortable: false},
          {label: 'Processor Model', field: 'processor_model',sortable: false},
          {label: 'GPU', field: 'gpu_type',sortable: false},
          {label: 'Price', field: 'price',sortable: false},
          {label: 'Offer', field: 'offer',sortable: false},
          {label: 'Reviews', field: 'reviews'},
          {label: 'Ratings', field: 'ratings'}]

      }
    },
    backToSov()
    { 
      window.location = '#/sovdetailed'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      this.destroyTables()
      this.initCols()
      localStorage.selected_SOVWebsite = this.selected_website
      localStorage.selected_category = this.device
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      let payload = { 
        "website": this.selected_website,
        "start_date1": moment(this.date.duration1From).format('YYYY-MM-DD'),
        "end_date1": moment(this.date.duration1To).format('YYYY-MM-DD'),
        "start_date2": moment(this.date.duration2From).format('YYYY-MM-DD'),
        "end_date2": moment(this.date.duration2To).format('YYYY-MM-DD'),
        "item_category": this.device
      }
      const url = "/api/v1/sov/products/compare"
      this.$http.post(url, payload).then(response => {
        self.rows_details = response.body.data
        console.log(this.rows_details)
        // for (let [idx, ds] of  response.body.data.entries())
        // {
        //   if(ds.product_name) ds.product_name = ds.product_name.replace('"','\'').replace('&amp;','&')
        //   if(ds.processor_type.indexOf('amd')!=-1) ds.processor_type = ds.processor_type.replace('amd','AMD')
        //   self.rows_details.push(ds)
        //   self.rows_details_full.push(ds)
        // }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
        console.log(err)
        console.log('err')
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      if (this.date.startDate2)
        this.date.startDate2 = moment(this.date.startDate2).format('YYYY-MM-DD')
    },
    destroyTables(){
      let self = this
      for (let [pidx, pd] of ['systems_added_','systems_removed_'].entries())
      {
        for (let [cidx, cd] of self.rows_details.entries())
        {
          $('#'+pd+cidx).DataTable().destroy();
        }  
      }
    },
    initDt2(){
      let self = this
      for (let [pidx, pd] of ['systems_added_','systems_removed_'].entries())
      {
        for (let [cidx, cd] of self.rows_details.entries())
        {
          $('#'+pd+cidx).DataTable({
            language: {
              search: "",
              paginate: {
                first: "",
                previous: "<",
                next: ">",
                last: "",
              },
              lengthMenu: "<h5>Show entries</h5> _MENU_",
            },
            // dom: '<"top">frt<"bottom"l>p<"clear">',
            pagingType: "full_numbers",
            info: true,
            initComplete: function () {
              this.api().columns().every( function () {
                  var column = this;
                
                    var select = $('<select><option value="">All</option></select>')
                    .appendTo( $(column.footer()).empty() )
                    .on( 'change', function () {
                        var val = $.fn.dataTable.util.escapeRegex(
                            $(this).val()
                        );      
        
                        column
                            .search( val ? '^'+val+'$' : '', true, false )
                            .draw();
                    } );
                    let arr = []    
                    let sortedArr = []
                    column.data().unique().sort().each( function ( d, j ) {
                      var myVal = $(d).text()
                      arr.push(myVal)
                    } ); 
                      
                    sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
                    
                    for (let [idx, ds] of sortedArr.entries())
                    {
                      select.append( '<option value="'+ds+'">'+ds+'</option>' )
                    } 
              } );
            }
          });
          var search = require("../../public/Icons_SVG/Search.svg");
          $(`${'#'+pd+cidx+"_filter"} > label > input`).attr(
            "placeholder",
            "Search"
          );
          $(`${'#'+pd+cidx+"_filter"} > label`).append(
            `<div class='search_icon'><img src='${search}' /></div>`
          );
          $(`${'#'+pd+cidx+"_length"} > label > select`).removeClass();
          $(`${'#'+pd+cidx+"_filter"} > label > input`).attr('style', 'padding: 10px 15px !important');
          // $(`${'#'+pd+cidx+"_filter"}`).prepend(`<div class='title'><strong>${pd.replace(/_/g, " ")}</strong></div>`);
        }
      }
    }
  }
}

</script>

<style>
div.dataTables_filter {
  display: flex;
  justify-content: flex-end;
}
.dataTables_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
div.dataTables_filter > label > input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px !important;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}
.dataTables_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}
.dataTables_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}
.dataTables_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
.dataTables_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
Table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}
.dataTables_filter div.search_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}
.dataTables_filter div.title {
  height: 35px;
  display: flex;
  justify-content: center;
}
.dataTables_filter > div.title > strong{
  padding-left:5px;
  font-size: 18px;
  font-weight: 600 !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}
.dataTables_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%)
    contrast(104%);
}
div[id$="_info"]{
  /* position: relative;
  top: 9px;
  left: 300px; */
  /* z-index: 100; */
  /* float: right; */
  /* width: 50vw; */
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}
.dataTables_paginate {
  position: relative;
  top: 5px;
  z-index: 100;
  float: right;
  width: 50vw;
}
/* .dataTables_length {
  position: relative;
  top: 27px;
  left: 10px;
  z-index: 100;
  width: 50vw;
} */
.dataTables_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}
.dataTables_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}
.dataTables_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}
.dataTables_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}
.dataTables_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}
Table[id^="systems_"] {
  border-radius: 20px 20px 0 0;
}
Table[id^="systems_"] .thead-normal,
Table[id^="systems_"] .thead-normal tr,
Table[id^="systems_"] .thead-normal > tr > th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}
Table[id^="systems_"] .thead-normal > tr > th:last-child {
  border-radius: 0 21px 0 0;
}
Table[id^="systems_"] .thead-normal > tr > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}
Table[id^="systems_"] .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}
Table[id^="systems_"] .thead-normal > tr > th.sorting:after {
  /* top: -40%; */
  font-size: 15px;
  color: var(--base_color-80);
  
}
Table[id^="systems_"] th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}
Table[id^="systems_"] tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
Table[id^="systems_"] tfoot th:first-child{
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
Table[id^="systems_"] tbody td {
  border-right: 1px solid var(--base_color-20) 
  !important;
  border-bottom: 1px solid var(--base_color-20) 
  !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}
Table[id^="systems_"] tbody td:first-child{
  border-left: 1px solid var(--base_color-20) !important;
}
Table[id^="systems_"] .even td {
  background: #fff !important;
}
Table[id^="systems_"] .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

Table_wrapper .bottom {
  margin: -30px;
}
Table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}
Table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

Table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

Table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}
Table_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}
</style>

<style scoped>
#sovdetailreport {
  font-family: "Poppins", sans-serif !important;
}
.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}
.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}
.exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}
.navigationButton:hover {
  background: var(--accent_color-80);
}
.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}
.datePickerBadge {
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}
.dateComponent {
  padding: 0px 10px 10px 10px;
  border: 1px solid var(--base_color-40);
  border-radius: 5px;
  background: white;
}
.dateComponentHeading{
  position: relative;
  bottom: 10px;
  width: fit-content;
  left: 1px;
  background-color: #fff;
}
.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 10px 0px !important;
}
/* .dateRangeHeading{
  position: relative;
  bottom: 16px;
  width: fit-content;
  background-color: #fff;
} */
/* pre-revamp styles */
.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:9
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
input.filval,button.filval{
  border-radius: 0;
  padding: 6px;
  height: 30px;

}
input.filval
{
  padding-top:5px;
}
button.filval
{
  padding-top:3px
}
.filter .row{
  justify-content: center;
}
.filter select, input.filval
{
  border:1px solid silver
}
.datebox
{
  width:inherit!important
}


</style>
